var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59785 6.11445L14.3791 10.8957C14.7096 11.2262 14.7096 11.7605 14.3791 12.0875L13.5846 12.882C13.2541 13.2125 12.7197 13.2125 12.3928 12.882L9.00371 9.49297L5.61465 12.882C5.28418 13.2125 4.7498 13.2125 4.42285 12.882L3.62832 12.0875C3.29785 11.757 3.29785 11.2227 3.62832 10.8957L8.40957 6.11445C8.73301 5.78398 9.26738 5.78398 9.59785 6.11445Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.539ac6c047dae6612707867675c49d2d.svg";
export { ForwardRef as ReactComponent };